import { render, staticRenderFns } from "./PageAbout.vue?vue&type=template&id=2300b4b6&"
import script from "./PageAbout.vue?vue&type=script&lang=js&"
export * from "./PageAbout.vue?vue&type=script&lang=js&"
import style0 from "./PageAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports